export const getTabs = (intl) => [
  {
    id: 0,
    name: intl.formatMessage({ id: 'controlpanel.global.all_plural' }),
    filters: null
  }
];
